import React from 'react';
import BannerSectionStyle3 from '../Section/BannerSection/BannerSectionStyle3';
import BannerSectionStyle4 from '../Section/BannerSection/BannerSectionStyle4';
import Section from '../Section';
import DepartmentSectionStyle2 from '../Section/DepartmentSection/DepartmentSectionStyle2';
import { pageTitle } from '../../helpers/PageTitle';
import servicesData from '../../data/services';

export default function Services() {
  pageTitle('Dr. L.D. Ramiah | Services');
  return (
    <>
      <BannerSectionStyle3
        bgUrl="/images/about/banner_bg.svg"
        imgUrl="/images/about/banner_img.png"
        title="Our Services"
        subTitle="Comprehensive primary care for individuals and families"
      />
      <Section topMd={200} topLg={150} topXl={110}>
        <DepartmentSectionStyle2
          sectionTitle="What Dr. Ramiah Offers"
          sectionTitleUp="GENERAL PRACTICE"
          data={servicesData}
        />
      </Section>
      <Section
        topMd={190}
        topLg={145}
        topXl={105}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
        className="cs_footer_margin_0"
      >
        <BannerSectionStyle4
          bgUrl="images/about/banner_bg_2.jpeg"
          title="Not sure of what you need? <br />Just ask."
          subTitle="Send us a message through the contact page and we'll be happy to point you in the right direction."
          center
        />
      </Section>
    </>
  );
}
